"use client";

import React, { useCallback, useEffect, useRef } from "react";
import styles from "./deleteModal.module.css";
import { HiOutlineExclamationTriangle, HiOutlineXMark } from "react-icons/hi2";
import { useDialogRouting } from "@/hooks/use-dialog-routing";

interface DeleteConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  description?: string;
  confirmText?: string; // <-- ADD THIS
  isLoading?: boolean;
}

export function DeleteConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  title = "Delete Lead?",
  description = "This action cannot be undone. All associated data including notes and history will be permanently removed.",
  confirmText = "Delete Permanently", // <-- ADD DEFAULT
  isLoading = false,
}: DeleteConfirmationModalProps) {
  useDialogRouting("DeleteConfirmationModal", isOpen, onClose);

  if (!isOpen) return null;

  return (
    <div
      className={styles.overlay}
      onClick={(e) => {
        e.stopPropagation();
        onClose();
      }}
    >
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <div className={styles.iconBox}>
            <HiOutlineExclamationTriangle size={24} />
          </div>
          <button
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onClose();
            }}
            className={styles.closeBtn}
            disabled={isLoading}
          >
            <HiOutlineXMark size={20} />
          </button>
        </div>

        <div className={styles.body}>
          <h3 className={styles.title}>{title}</h3>
          <p className={styles.description}>{description}</p>
        </div>

        <div className={styles.footer}>
          <button
            className={styles.cancelBtn}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onClose();
            }}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            className={styles.deleteBtn}
            onClick={() => {
              onClose();
              onConfirm();
            }}
            disabled={isLoading}
          >
            {isLoading ? "Deleting..." : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
